
import { mapGetters } from 'vuex';

export default {
  name: 'AppNoReview',
  props: {
    message: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapGetters(['hasSelectedFilters']),
    noItemMessage() {
      if (this.message) return this.message;

      const type = this.hasSelectedFilters ? 'filtered' : 'none';
      return this.$t(`no_item_message.${type}`);
    }
  }
};
